export function getVerificationPaymentId(
  beginPaymentId?: string,
  plexoReferenceId?: string | null,
): string {
  return beginPaymentId || plexoReferenceId || '';
}

export function getPaymentReference(
  verifiedPlexoReferenceId?: string | null,
  callbackPlexoReferenceId?: string | null,
  verifiedBeginPaymentId?: string | null,
  requestedBeginPaymentId?: string,
): string {
  return (
    verifiedPlexoReferenceId ||
    callbackPlexoReferenceId ||
    verifiedBeginPaymentId ||
    requestedBeginPaymentId ||
    ''
  );
}
